/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
import _ from 'underscore';
import legacy$ from 'jquery';
import { http } from '@bingads-webui/http-util';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import state from '@bingads-webui-component-legacy/state/index';
import { queryify } from '@bingads-webui/url-util';
import { getFwdLinkId } from '@bingads-webui-component-legacy/api-errors-campaign/map/editorialRejectionFwdLinkId';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import { getLocationString } from '@bingads-webui-campaign/delivery-status-popup-factory';
import SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import { DisclaimerAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
const i18nCommon = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/ads-tab/common');

const EditorialRejected = 70;
const EditorialApprovedLimited = 200;
const AppealableStatus = [EditorialRejected, EditorialApprovedLimited, 'EditorialRejected', 'EditorialApprovedLimited'];

function getEditorialErrorMessage(reaonsCode, permissions) {
  let message = i18n.getString(`Error_Editorial_Raw_${reaonsCode}`) ||
            i18n.getString(`Editorial_RejectionReason_${reaonsCode}`);

  if (!message) {
    logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'getEditorialErrorMessageForEditorialAppeal',
      `Missed Editorial message mapping for code: ${reaonsCode}, use default`);
    message = i18n.getString('EditorialReasons_Default');
  }

  const fwLinkId = getFwdLinkId(reaonsCode);
  let fwlink = `http://go.microsoft.com/fwlink?LinkId=${fwLinkId}`;

  if (permissions && permissions.IsDomesticSimplifiedChineseEnabled) {
    fwlink = 'https://about.ads.microsoft.com/zh-cn/pilotpolicy.pdf';
  }

  return `<a href="${fwlink}" target="_apexPlatformHelp">${message}</a>`;
}

export function isAppealableStatus(status) {
  return _.contains(AppealableStatus, status);
}

export function getInlineBulkAppealUrl(controller, action) {
  return queryify(`/Campaign/${controller}/${action}`, _.pick({
    cid: state.get('customer_id'),
    aid: state.get('account_id'),
    cmpid: state.get('campaign_id'),
    adgId: state.get('adgroup_id'),
  }, Boolean));
}


export function ids2params(ids) {
  return _.map(ids, (id, index) => {
    return `ids[${index}]=${id}`;
  }).join('&');
}

const getEntityTypeFromController = (controller) => {
  switch (controller) {
  case 'Ads':
    return 'Ad';
  case 'AssetGroup':
    return 'AssetGroup';
  case 'Extension':
    return 'Extension';
  case 'Keywords':
  default:
    return 'Keyword';
  }
};

export const generateExtensionUrl = (url, adextension, scope) => {
  let type = scope.type;

  if (type === 'sitelink') {
    type = 'Sitelink2';
  } else if (type === 'businessinfo') {
    type = 'logo';
  }

  let args = _.extend({
    aid: scope.aid,
    cid: scope.cid,
    cmpid: scope.campaignId,
    type: type.replace('AdExtension', ''),
    adExtensionId: adextension && adextension.AdExtension && adextension.AdExtension.Id,
    campaignId: scope.campaignId || (adextension.Campaign && adextension.Campaign.Id),
    version: adextension && adextension.AdExtension && adextension.AdExtension.Version,
  });

  if ( type !== 'disclaimer') {
    args = _.extend(args, {
      adgid: scope.adGroupId,
      adGroupId: scope.adGroupId || (adextension.AdGroup && adextension.AdGroup.Id),
    });
  }

  return queryify(url, args);
};

export function processRejectReasonsFromOdata(resultData, controller, permissions, Entities) {
  const appealIds = [];
  const rejectedReasons = [];
  const rejectedTerms = [];
  const resultValues = _.result(resultData, 'value') || resultData;

  // process each reason and generate reason string
  // as the user only need reasons, merge it here
  const reasonsAndPublisherCountriesMap = {};


  _.each(resultValues, ({EntityId, Reasons, IsAppealable}) => {
    if (IsAppealable) {
      appealIds.push(EntityId);

      _.each(Reasons, ({ReasonCode, Term, Location, LanguageToCountries, RejectionCountries}) => {
        const rejectedCountries = RejectionCountries || _.uniq(_.flatten(_.pluck(LanguageToCountries, 'PublisherCountries')));

        let reasonString = getEditorialErrorMessage(ReasonCode, permissions);
        // merge the reason & publishercountries

        if (reasonsAndPublisherCountriesMap[reasonString]) {
          reasonsAndPublisherCountriesMap[reasonString] =
            _.union(reasonsAndPublisherCountriesMap[reasonString], rejectedCountries);
        } else {
          reasonsAndPublisherCountriesMap[reasonString] = rejectedCountries;
        }

        let termString = Term;
        let locationStrings = typeof Location === 'string' ? Location : getLocationString({location: Location, commonI18n: i18nCommon});

        if (locationStrings) {
          termString = `${termString}(${i18n.getString('LblLocationString')}${locationStrings})`;
        }
        rejectedTerms.push(termString);
      });
    }
  });

  _.each(reasonsAndPublisherCountriesMap, (countries, reasonString) => {
    let rejectionReasonString = reasonString;
    const rejectedCountryStrings = _.map(countries, (country) => {
      return  controller === 'Extension' ? country : i18n.getString(`PublisherCountry_${country}`);
    });

    if (!_.isEmpty(rejectedCountryStrings)) {
      rejectionReasonString = `${reasonString} (${rejectedCountryStrings.join(', ')})`;
    }
    rejectedReasons.push(rejectionReasonString);
  });

  const entityType = getEntityTypeFromController(controller);

  return {
    appealIds,
    appealData: [{
      Appeal: false,
      Justification: null,
      IsAppealable: true,
      RejectedReasons: rejectedReasons,
      RejectedTerms: rejectedTerms,
      EntityType: entityType,
    }],
    Entities,
  };
}

function getAppealRejectionsOdataNew(controller, _action, {
  adgroupEntityIds = [],
  ids,
  adgroupId,
  grid,
  success,
  jsonError,
  permissions,
}) {
  const op = {};
  let Entities = {};

  if (controller === 'Asset') {
    _.each(ids, (id) => {
      Entities[id.EntityId] = id.EntityType;
    });
    op.data =  {
      Entities: JSON.stringify(Entities),
    };
  } else if (adgroupEntityIds && !_.isEmpty(adgroupEntityIds)) {
    op.data = {
      'EntityIdsParentIds': adgroupEntityIds,
    };
  } else if (!adgroupId) {
    op.data = {
      'EntityIdsParentIds': _.map(ids, (id) => {
        const rowItem = grid.gridView.itemWithKey(id);
        const {Id: EntityId, AdGroup: adgroup } = rowItem;

        return {
          EntityId,
          ParentId: adgroup.Id,
        };
      }),
    };
  }

  const adgroupIdParameter = adgroupId ? `/AdGroups(${adgroupId})` : '';

  let odataUrl = '';

  switch (controller) {
  case 'Ads':
    odataUrl = `/Customers()/Accounts()${adgroupIdParameter}/Ads/Default.EditorialReasons`;
    break;

  case 'Keyword':
    odataUrl = `/Customers()/Accounts()${adgroupIdParameter}/Keywords/Default.EditorialReasons`;
    break;

  case 'Asset':
    odataUrl = '/Customers()/Accounts()/Assets/GetEditorialReasons';
    break;

  default:
    break;
  }

  return odata.post(odataUrl, op)
    .then((data) => {
      if (data && !data.Errors) {
        const processedData = processRejectReasonsFromOdata(data, controller, permissions, Entities);

        success(processedData, adgroupId);
      } else {
        jsonError();
      }
    })
    .catch(() => {
      jsonError();
    });
}
function requestExtensionRejectReason({
  url,
  EntityId,
  controller,
  success,
  jsonError,
  permissions,
}) {
  return http.post({
    url,
    data: { __RequestVerificationToken: legacy$('input[name="__RequestVerificationToken"]').val()},
    contentType: 'application/x-www-form-urlencoded',
  }).then((data) => {
    if (data && !data.Errors) {
      const processedData = processRejectReasonsFromOdata({
        value: [{
          EntityId,
          Reasons: data.RejectionReasons,
          IsAppealable: data.IsAppealable,
        }],
      }, controller, permissions);

      success(processedData);
    } else {
      jsonError();
    }
  },
  ).catch(() => {
    jsonError();
  });
}

function getExtensionAppealRejections({
  ids,
  controller,
  grid,
  success,
  jsonError,
  permissions,
  scope,
}) {
  let url = '/campaign/AdExtensions.m/GetRejectionReasonData';

  if (scope.type === 'disclaimer') {
    const disclaimerRepos = new SharedRepository({
      schema: DisclaimerAdExtension,
      afterChangeComitted: _.noop,
    });
    let campaignId = ids[0];

    if (grid && grid.config && grid.config.name === 'summary_tab_ad') {
      const rowItem = grid.gridView.itemWithKey(ids[0]);

      campaignId = rowItem.Campaign.Id;
    }

    return disclaimerRepos.association.findAll({
      where: {
        campaignId,
      },
    }).then((adextension) => {
      url = generateExtensionUrl(url, {AdExtension: adextension && adextension[0], Campaign: {Id: campaignId}}, scope);
      return requestExtensionRejectReason({
        url,
        EntityId: adextension && adextension[0] && adextension[0].Id,
        controller,
        success,
        jsonError,
        permissions,
      });
    });
  }

  const adextension = grid.gridView.itemWithKey(ids[0]);

  url = generateExtensionUrl(url, adextension, scope);
  return requestExtensionRejectReason({
    url,
    EntityId: adextension && adextension.AdExtension && adextension.AdExtension.Id,
    controller,
    success,
    jsonError,
    permissions,
  });
}


export function getAppealRejections(controller, action, ids, {
  grid,
  adgroupEntityIds,
  adgroupId,
  rowId,
  success,
  jsonError,
  permissions,
  scope,
  error = _.noop,
}) {
  if (grid && grid.gridView) {
    if (controller === 'Extension') {
      return  getExtensionAppealRejections({
        ids,
        controller,
        success,
        grid,
        permissions,
        jsonError,
        error,
        scope});
    } else {
      return  getAppealRejectionsOdataNew(controller, action, {
        ids,
        adgroupEntityIds,
        success,
        grid,
        adgroupId,
        rowId,
        permissions,
        jsonError});
    }
  } else {
    return legacy$.advertiser.ajaxPost({
      url: getInlineBulkAppealUrl(controller, action),
      data: ids2params(ids),
      onSuccess: (data) => {
        if (data && !data.Errors) {
          success(data);
        }
      },
      onError: error,
      onJsonError: jsonError,
    });
  }
}

export function requestExceptionOdata(grid,
  controller,
  scopeId,
  appealIds,
  appealData,
  Entities,
  successCallBack,
  exceptionCalLBack,
  finallyCallBack,
) {
  if (grid.gridView) {
    const adgroupId = state.get('adgroup_id') || scopeId;
    let op = {
      data: {
        'EntityIds': scopeId ? null : appealIds,
        JustificationText: appealData.Justification,
      },
    };

    if (controller === 'Asset') {
      op.data =  {
        Entities: JSON.stringify(Entities),
        JustificationText: appealData.Justification,
      };
    }

    let odataUrl = adgroupId ?
      `/Customers()/Accounts()/AdGroups(${adgroupId})/Ads/Default.CreateAppeals` :
      '/Customers()/Accounts()/Ads/Default.CreateAppeals';

    switch (controller) {
    case 'Keyword':
      odataUrl = adgroupId ?
        `/Customers()/Accounts()/AdGroups(${adgroupId})/Keywords/Default.CreateAppeals` :
        '/Customers()/Accounts()/Keywords/Default.CreateAppeals';
      break;
    case 'Extension':
      odataUrl = '/Customers()/Accounts()/AdExtensions/Default.CreateAppeals';
      break;
    case 'Asset':
      odataUrl = '/Customers()/Accounts()/Assets/CreateAppeals';
      break;

    default:
    case 'Ads':
      break;
    }

    odata.post(odataUrl, op)
      .then(() => {
        successCallBack();
      })
      .catch((response) => {
        exceptionCalLBack(response);
      })
      .finally(() => {
        if (finallyCallBack) {
          finallyCallBack();
        }
      });
  }
}
